import { render, staticRenderFns } from "./affected_articles.vue?vue&type=template&id=8c105e08&scoped=true&"
import script from "./affected_articles.vue?vue&type=script&lang=js&"
export * from "./affected_articles.vue?vue&type=script&lang=js&"
import style0 from "./affected_articles.vue?vue&type=style&index=0&id=8c105e08&lang=less&scoped=true&"
import style1 from "./affected_articles.vue?vue&type=style&index=1&id=8c105e08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c105e08",
  null
  
)

export default component.exports